export const getCurrencySymbol = (currency: string): string =>
  ({
    USD: '$',
    AUD: 'A$',
    CAD: 'CA$',
    EUR: '€',
    GBP: '£',
    INR: '₹',
    MXN: 'MX$',
    NZD: 'NZ$',
    BRL: 'R$',
  }[currency.toUpperCase()] || '');
